import { render, staticRenderFns } from "./WorkHoursView.vue?vue&type=template&id=2cf67690"
import script from "./WorkHoursView.vue?vue&type=script&lang=ts"
export * from "./WorkHoursView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports